import React from "react";
import "./about.css";

export default function About() {
  return (
    <div className="about">
      <p>Olá, eu sou</p>

      <h1>Júlia Miranda</h1>

      <p>
        Desenvolvedora Full Stack com 3+ anos de experiência em desenvolvimento de software.
        <br/>
        Bacharel em Ciência da Computação pela Universidade Federal de Ouro Preto e Técnica em Eletrotécnica pelo Instituto Federal de Educação, Ciência e Tecnologia de Minas Gerais.
        Apresenta uma bagagem diversificada em áreas do desenvolvimento como Mobile, Front-End, Back-End e Hiper Automação.  
      </p>
    </div>
  );
}
